import { isHidden } from "./utilities";

const _MENU_TOGGLE = "#menu-toggle";
const _MENU_BUTTON = ".c-menu__toggle";
const _SIDEBAR = ".c-menu__items";
const _MENU_ITEM = "a";
const _CLOSE_TITLE = "Close the menu";
const _OPEN_TITLE = "Open the menu";

const toggleMenu =
    ({ menutoggle, menubutton, allMenuItems }) =>
        (e) => {
            if (isHidden(menubutton)) {
                return;
            }
            const keysToScan = ["Enter", "Tab", "Escape"];

            if (e.type === "keydown" && !keysToScan.includes(e.key)) {
                return;
            }

            if (e.type === "keydown" && e.key === "Tab") {
                if (menutoggle.checked && e.shiftKey) {
                    e.preventDefault();
                    allMenuItems[allMenuItems.length - 1].focus({
                        focusVisible: true,
                    });
                }
                if (menutoggle.checked && !e.shiftKey) {
                    e.preventDefault();
                    allMenuItems[0].focus({ focusVisible: true });
                }
                return;
            }

            if (e.type === "keydown") {
                menutoggle.click();
            }

            const closeAction = () => {
                menubutton.title = _CLOSE_TITLE;
                menubutton.ariaLabel = _CLOSE_TITLE;
                menubutton.focus({ focusVisible: true });
            };

            const openAction = () => {
                menubutton.title = _OPEN_TITLE;
                menubutton.ariaLabel = _OPEN_TITLE;
                allMenuItems[0].focus({ focusVisible: true });
            };

            menutoggle.checked ? openAction() : closeAction();
        };

const handleMenuEvents =
    ({ allMenuItems, menubutton, menutoggle }) =>
        (e) => {
            if (isHidden(menubutton)) {
                return;
            }
            const keysToScan = ["Tab", "Escape"];

            if (!keysToScan.includes(e.key)) {
                return;
            }

            if (e.key === "Escape") {
                menutoggle.click();
                menubutton.focus({ focusVisible: true });
                return;
            }

            const lastMenuItem = allMenuItems[allMenuItems.length - 1];

            if (e.target === lastMenuItem && !e.shiftKey) {
                e.preventDefault();
                menubutton.focus({ focusVisible: true });
            }

            if (e.target === allMenuItems[0] && e.shiftKey) {
                e.preventDefault();
                menubutton.focus({ focusVisible: true });
            }
        };

const presetListenerEvent = (DOMElements) => (CallbackFn) =>
    CallbackFn(DOMElements);

const setupFocusTrap = () => {
    const menubutton = document.querySelector(_MENU_BUTTON)! as HTMLElement;
    
    if (!menubutton) return;
    
    const menutoggle = document.querySelector(_MENU_TOGGLE)!;
    const menuList = document.querySelector(_SIDEBAR)!;
    const allMenuItems = menuList?.querySelectorAll(_MENU_ITEM)!;
    const elems = { menutoggle, menubutton, allMenuItems };
    const presetLE = presetListenerEvent(elems);

    menubutton.title = _OPEN_TITLE;
    menubutton.ariaLabel = _OPEN_TITLE;
    menubutton.addEventListener("keydown", presetLE(toggleMenu));
    menubutton.addEventListener("click", presetLE(toggleMenu));
    menuList.addEventListener("keydown", presetLE(handleMenuEvents));
    menuList.addEventListener("click", presetLE(handleMenuEvents));
};

document.addEventListener("DOMContentLoaded", () => {
    setTimeout(setupFocusTrap, 500);
});